export default function find(array, predicate) {
    for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/common/find.js
// module id = 2371
// module chunks = 29